
import { createSafeHTML } from '@/utils/sanitize';
import { OptimizedImage } from '@/components/OptimizedImage';

interface TextWithDualImagesContent {
  main_text: string;
  image1_url: string;
  image1_alt: string;
  image2_url: string;
  image2_alt: string;
}

interface TextWithDualImagesBlockProps {
  content: TextWithDualImagesContent;
}

export const TextWithDualImagesBlock = ({ content }: TextWithDualImagesBlockProps) => {
  const { main_text, image1_url, image1_alt, image2_url, image2_alt } = content;

  return (
    <section className="py-16 px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        {/* Main Text Content */}
        <div className="mb-12">
          <div 
            className="text-lg md:text-xl text-gray-700 leading-relaxed max-w-4xl mx-auto text-center blog-content-container"
            dangerouslySetInnerHTML={createSafeHTML(main_text)}
          />
        </div>

        {/* Dual Images Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {/* First Image */}
          {image1_url && (
            <div className="flex justify-center">
              <OptimizedImage
                src={image1_url}
                alt={image1_alt || 'Illustration'}
                width={400}
                height={300}
                className="rounded-lg shadow-lg object-cover"
                optimization={{ quality: 85 }}
              />
            </div>
          )}

          {/* Second Image */}
          {image2_url && (
            <div className="flex justify-center">
              <OptimizedImage
                src={image2_url}
                alt={image2_alt || 'Illustration'}
                width={400}
                height={300}
                className="rounded-lg shadow-lg object-cover"
                optimization={{ quality: 85 }}
              />
            </div>
          )}
        </div>
      </div>
    </section>
  );
};
